module.exports = __webpack_public_path__ + "img/Red-L-1@2x.928b45b5.png";